import produce from "immer";

const defaultState = {
    items: [],
    rewardsAvailable: null
};

let mapReward = function (reward) {
    return {
        id: reward.id,
        title: reward.title,
        subtitle: reward.subtitle,
        friendlyName: reward.friendlyName,
        passionPoint: reward.passionPoint,
        imageFetchId: reward.imageFetchId
    };
};
export default function(state = defaultState, action) {
    return produce(state, draft => {
        switch (action.type) {
            case 'REWARDS_FETCHED':
                draft.items = action.rewards.map(mapReward);
                draft.rewardsAvailable = draft.items.length > 0;
                return;
            default:
                return state;
        }
    });
}